// extracted by mini-css-extract-plugin
module.exports = {"customBackground":"otm-rec-banner_customBackground__Bacjv"};